export default "__VITE_ASSET__BE2YoK7n__"